import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFieldDropdown, DatePickerField, BaasicFormControls, BaasicButton } from 'core/components';
import { ApplicationEditLayout, Content, PageFooter } from 'core/layouts';

function ImportPatientCreateTemplate({ editView , t}) {
    const {
        contentLoading,
        form,
        contactRelationshipStore,
        primaryInsuranceStore,
        secondaryInsuranceStore,
        rootStore,
        diagnosisCodesStore,
        doctorStore,
        goToImport,
        genderStore,
        stateStore,
        oldPrimaryInsuranceStore,
        oldPrimaryInsuranceDisplayed,
        toggleOldPrimaryInsurance,
        invalidateInsurances,
        hasPermission
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <h4 className="form__title">Personal data</h4>
                                    <div className="row">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('firstName')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('lastName')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('dateOfBirth')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('ssn')} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                <h4 className="form__title">Contact Data</h4>
                                    <div className="row">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('contactRelationship')} store={contactRelationshipStore}/>
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactFirstName')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactLastName')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactAddressLine1')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactAddressLine2')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactCity')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactCountry')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('contactState')} store={stateStore}/>
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactPostalCode')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('contactPhone')} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <h4 className="form__title">Clinical data</h4>
                                    <div className="row">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('gender')} store={genderStore} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('height')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('weight')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('patientDetailDiagnosisCodes')} store={diagnosisCodesStore} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('doc')} store={doctorStore}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <div className="u-flex--primary form__title">
                                        <h4 className="form__title--secondary">Primary insurance information</h4>
                                        <BaasicButton className="btn btn--base btn--primary u-mar--left--tny u-flex--last" 
                                                  label={'Refresh Insurances'} 
                                                  icon="u-icon u-icon--sml u-icon--synchronize" 
                                                  onClick={invalidateInsurances} 
                                                  disabled={!hasPermission}
                                                  ></BaasicButton>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('primaryInsuranceName')} store={primaryInsuranceStore} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('primaryInsurancePolicyNumber')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <DatePickerField field={form.$('primaryInsuranceStartDate')} />
                                        </div>
                                    </div>
                                    <div className="card card--secondary">
                                        {oldPrimaryInsuranceDisplayed && 
                                            <div className="row u-mar--bottom--sml">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('oldPrimaryInsuranceName')} store={oldPrimaryInsuranceStore} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('oldPrimaryInsurancePolicyNumber')} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <DatePickerField field={form.$('oldPrimaryInsuranceStartDate')} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <DatePickerField field={form.$('oldPrimaryInsuranceEndDate')} />
                                                </div>
                                            </div> 
                                        }
                                        <BaasicButton
                                            onClick={() => toggleOldPrimaryInsurance()}
                                            className='btn btn--base btn--link'
                                            icon={(oldPrimaryInsuranceDisplayed ? 'u-icon--remove' : 'u-icon--add') + ' u-icon u-icon--med u-align--v--7'}
                                            label={(oldPrimaryInsuranceDisplayed ? 'Remove' : 'Add') + ' Old Primary Insurance'}
                                            disabled={!hasPermission}
                                        />   
                                    </div>                                 
                                    
                                </div>
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <h4 className="form__title">Secondary insurance information</h4>
                                    <div className="row">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BaasicFieldDropdown field={form.$('secondaryInsuranceName')} store={secondaryInsuranceStore}/>
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('secondaryInsurancePolicyNumber')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <DatePickerField field={form.$('secondaryInsuranceStartDate')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <DatePickerField field={form.$('secondaryInsuranceEndDate')} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
            <PageFooter>
                <BaasicFormControls form={form} onSubmit={form.onSubmit} authorized={hasPermission} />
                <BaasicButton className='btn btn--base btn--primary' 
                                label={'Create Patient'} 
                                onClick={() => goToImport()} 
                                authorized={hasPermission}
                                />
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
        </ApplicationEditLayout>
    )
}

ImportPatientCreateTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ImportPatientCreateTemplate);
